<template>
  <div class="card">
    <div class="card-body pt-12">
      <h5 class="pb-4 border-bottom mb-4">Подписка</h5>
      <LoadingBlock :loading="!summary.loaded">
        <p v-if="summary.forbidden" class="text-muted mb-0">Тарифом и оплатой управляет владелец компании.</p>
        <div v-else-if="summary.error" class="alert alert-danger mb-0">{{ summary.error }}</div>

        <div v-else-if="summary.loaded && !subscription" class="text-center py-4">
          <i class="ti ti-credit-card-off text-muted mb-3" style="font-size: 3rem;"></i>
          <p class="text-muted mb-4">Тариф не подключён</p>
          <RouterLink :to="{name: 'billing-plans'}" class="btn btn-primary">Выбрать тариф</RouterLink>
        </div>

        <template v-else-if="subscription">
          <ul class="list-unstyled mb-4">
            <li class="mb-2 d-flex align-items-center gap-2 flex-wrap">
              <span class="h6 mb-0">Тариф:</span>
              <span class="badge bg-primary">{{ subscription.plan.name }}</span>
              <span class="badge" :class="status.class">{{ status.label }}</span>
            </li>
            <li v-if="!subscription.is_free" class="mb-2" :class="tariff.tone === 'muted' ? '' : 'text-' + tariff.tone">
              <template v-if="subscription.cancel_at_period_end">
                Отменена, доступ сохранится до {{ formatDate(subscription.period_end) }}
              </template>
              <template v-else>
                <span class="h6">{{ subscription.status === 'trialing' ? 'Пробный период до' : 'Действует до' }}:</span>
                {{ formatDate(subscription.period_end) }}
              </template>
            </li>
            <li v-if="subscription.billing_method" class="mb-2">
              <span class="h6">Оплачена:</span> {{ billingMethodName(subscription.billing_method) }}
            </li>          </ul>

          <!-- Лимиты тарифа по продукту: из публичного каталога (если тариф в нём есть) -->
          <div v-if="limits.length" class="mb-4">
            <h6 class="mb-3">Лимиты тарифа:</h6>
            <div v-for="item in limits" :key="item.key" class="border rounded p-3 mb-2">
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-medium">{{ limitName(item.key) }}</span>
                <span class="badge bg-light text-dark">{{ item.value.toLocaleString('ru-RU') }}</span>
              </div>
            </div>
          </div>
        </template>

        <div v-if="!summary.forbidden && !summary.error && summary.loaded" class="d-flex flex-wrap gap-2">
          <RouterLink :to="{name: 'billing'}" class="btn btn-primary">
            <i class="ti ti-credit-card me-2"></i>Тариф и оплата
          </RouterLink>
          <RouterLink v-if="subscription" :to="{name: 'billing-plans'}" class="btn btn-outline-primary">
            <i class="ti ti-refresh me-2"></i>{{ subscription.is_free ? 'Выбрать платный тариф' : 'Сменить тариф' }}
          </RouterLink>
        </div>
      </LoadingBlock>
    </div>
  </div>
</template>

<script>
import {BILLING_PRODUCT} from "../config";
import {LoadingBlock} from "../host";
import {getPlans} from "../api";
import {describeTariff, tariffSummary} from "../summary";
import {billingMethodName, formatDate, limitName, sortEntitlements, subscriptionStatus} from "../format";

export default {
  name: 'BillingTariffCard',
  components: {LoadingBlock},
  data() {
    return {
      plans: [],
    }
  },
  computed: {
    summary() {
      return tariffSummary
    },
    subscription() {
      return tariffSummary.subscription
    },
    tariff() {
      return describeTariff(this.subscription)
    },
    status() {
      return subscriptionStatus(this.subscription.status)
    },
    limits() {
      const plan = this.subscription && this.plans.find((item) => item.id === this.subscription.plan.id)
      return plan ? sortEntitlements(plan.entitlements.filter((item) => item.product === BILLING_PRODUCT)) : []
    },
  },
  methods: {billingMethodName, formatDate, limitName},
  async mounted() {
    await tariffSummary.load()
    try {
      this.plans = await getPlans()
    } catch (e) {
      // Без каталога просто не показываем лимиты
      this.plans = []
    }
  },
}
</script>
